enum PhoneNumberType {
  LOCAL = 'LOCAL',
  TOLL_FREE = 'TOLL_FREE',
}

export enum PhoneNumberCapability {
  MMS = 'MMS',
  SMS = 'SMS',
  VOICE = 'VOICE',
}

export enum PhoneNumberStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export default interface CompanyPhoneNumber {
  id: string;
  status: PhoneNumberStatus;
  createdAt: string;
  createdBy: {
    id: string;
  };
  updatedAt: string;
  updatedBy: {
    id: string;
  };
  accountId: string;
  phoneNumber: string;
  capabilities: PhoneNumberCapability[];
  locality: string;
  region: string;
  phoneNumberType: PhoneNumberType;
  externalId: string;
}
